import { styled, Theme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const MainContainer = styled('div')(({ theme, isRevision }: { theme: Theme; isRevision?: boolean }) => ({
  display: 'flex',
  alignItems: 'center',
  background: theme.palette.type === 'dark' ? '#0b0f14' : '#fff',
  borderRight: isRevision ? undefined : theme.palette.type === 'dark' ? '1px solid #2d343e' : '1px solid #cdd9e9',
  border: isRevision ? `1px solid ${COLORS.REVISION_BORDER} !important` : undefined,
  borderRadius: 8,
  width: '100%',
  cursor: 'pointer',
}));

export const Left = styled('div')(({ theme }) => ({
  background: theme.palette.type === 'dark' ? '#10151c' : '#f7f7f7',
  borderRight: theme.palette.type === 'dark' ? '1px solid #2d343e' : '1px solid #cdd9e9',
  borderTopLeftRadius: 8,
  borderBottomLeftRadius: 8,
  minWidth: 108,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: 15,
  height: '100%',
}));

export const Right = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '15px 30px',
  width: '60%',
  // flex: 1,
  // '& > div > p': {
  //   lineHeight: 1.2,
  // },

  '& > p': {
    // maxWidth: '100%',
    // // width: '100%',
    // textOverflow: 'ellipsis',
    // whiteSpace: 'nowrap',
    // overflow: 'hidden',

    float: 'left',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

    /* new css */
    maxWidth: '100%',
  },
}));

export const CustomIconButton = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: 'auto',
  marginRight: 20,

  '& .MuiSvgIcon-root': {
    width: 14,
    height: 14,
  },
}));
